var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layer_section-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "align-box size-auto" }, [
      _c(
        "button",
        {
          staticClass: "btn-modal_close",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("layer")
            }
          }
        },
        [_vm._v("확인")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layer-content campaign-detail" }, [
      _c("h2", { staticClass: "campaign-detail__title" }, [
        _vm._v("\n              2023년 9월 신규 ABO 프로모션 "),
        _c("br", { staticClass: "mobile" }),
        _vm._v("후원 조건 안내\n          ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "abo-guide" }, [
        _c("div", { staticClass: "abo-guide__block" }, [
          _c("h3", { staticClass: "abo-build__title" }, [
            _vm._v("1. 기간: 2023년 9월 1일 (금) 오전 9시 ~ "),
            _c("br", { staticClass: "mobile" }),
            _vm._v("11월 30일 (목) 오후 11시 50분")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "abo-guide__block" }, [
          _c("h3", { staticClass: "abo-build__title" }, [
            _vm._v(
              "\n                      2. 대상자: 2023년 9월 1일 부 유자격 플래티늄 이상 리더\n                  "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "abo-guide__block" }, [
          _c("h3", { staticClass: "abo-build__title" }, [
            _vm._v(
              "\n                      3. 혜택: 전국 체인 호텔/리조트 숙박권 증정\n                  "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "abo-guide__block" }, [
          _c("h3", { staticClass: "abo-build__title" }, [
            _vm._v(
              "\n                      4. 달성조건: \n                      "
            ),
            _c("span", [
              _vm._v(
                "① 유자격 PT그룹 내 9월 신규 ABO 프로모션 택을 받은 신규 ABO를 30조 이상 후원"
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "② ①번에 해당하는 신규 ABO 중 9월 ~ 11월 (3개월) 동안 장바구니 스마트 오더 7조 이상 유지"
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "※ ‘신규 ABO 30조’는 20만원 이상 구매 또는 ABC에서 10만원 이상 구매한 신규 ABO를 모두 포함한 금액입니다."
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "※ 3개월 장바구니 스마트 오더의 경우에도 ‘코어제품 10만원 이상 구매 시’ 혜택이 증정됩니다."
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a7fad62", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a7fad62","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/sales/dashboard3/component/layerAttainment.vue
// module id = null
// module chunks = 